<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('site.destroyheading')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <h4>
          {{$t('site.destroywarning')}}
        </h4>
        <p>
          {{$t('site.destroymessage')}}
        </p>
        <table class="table table--overview">
          <tr v-for="(site, index) in sitesFilter" v-bind:key="index">
            <td><strong>{{site.data.name}}</strong></td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row class="contentcontainer__footer" align-h="end">
      <b-col cols="auto">
        <router-link tag="span" to="/sites" exact>
          <a class="backlink">
            {{$t('sites.stopdestroy')}}
          </a>
        </router-link>
        <button v-on:click="localRemove" class="btn btn--danger">
          {{$t('sites.confirmdestroy')}}
        </button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {

  computed: {

    ...mapState('site', [
      'sites',
      'siteSelected'
    ]),

    sitesCounter () {
      if (typeof this.sites.data === 'undefined') {
        return 0
      }

      return this.sites.data.length
    },

    sitesFilter () {
      if (typeof this.sites.data === 'undefined') {
        return []
      }

      return this.sites.data.filter((site) => {
        return this.siteSelected.indexOf(site.id) !== -1
      })
    }
  },

  methods: {
    ...mapMutations('common', [
      'endLoading',
      'resetLoading'
    ]),

    ...mapActions('site', [
      'removeAllSelectedSites'
    ]),

    localRemove () {
      this.removeAllSelectedSites()
      this.$router.push({
        name: 'dashboard'
      })
    }
  },

  mounted () {
    this.endLoading()
  }
}
</script>
